/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

export default {
    name: "TEMPLATE-DIALOG",
    path: "/app/interpretacion/pendientes/dialog",
    component: () => import("@/app/views/crud/CrudDialogView.vue"),
    meta: {
      service: () => import("@/app/services/TemplateDialogService"),
      table: () => import("@/app/components/dialog/templateDialog/TemplateDialogTable.vue"),
      form: () => import("@/app/components/dialog/templateDialog/TemplateDialogForm.vue"),
      header: {
        icono: "mdi-wrench",
        texto: "Plantilla",
        textNew: "Nueva plantilla",
        textEdit: "Editar plantilla",
      },
      requireAuth: true,
      hideButtonAdd: true,
      addButtonText: "AGREGAR PLANTILLA",
    },
  };